module.exports = __webpack_public_path__ + "static/img/nguyenngocyen.b3fc977.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nguyenngocyen.png
// module id = hPY0
// module chunks = 1